// Signup services

export const steps = {
  'LDG': {
    status: null,
    index: 0,
    header: 'signup.steps.LDG.header',
    title: 'signup.steps.LDG.title',
    subtitle: 'signup.steps.LDG.subtitle',
    icon: 'loading',
    loading: true,
    cta: {
      toggle: false,
      text: '',
    },
  },
  'ACC': {
    status: 'ACC',
    express: false,
    index: 1,
    header: 'signup.steps.ACC.header',
    title: 'signup.steps.ACC.title',
    subtitle: 'signup.steps.ACC.subtitle',
    icon: 'profile',
    loading: false,
    cta: {
      toggle: false,
      text: 'signup.steps.ACC.cta',
    },
    completion: 0
  },
  'ACCX': {
    status: ['ACC', 'ENR'],
    express: true,
    index: 1,
    component: 'step3B',
    header: 'signup.steps.ACC.header',
    title: 'signup.steps.ACC.title',
    subtitle: 'signup.steps.ACC.subtitle',
    icon: 'profile',
    loading: false,
    cta: {
      toggle: false,
      text: 'signup.steps.ACCX.cta',
    },
    profile: 0,
    docs: {
      completion: 0,
      items: [],
    },
    completion: 0,
  },
  'FDBX': {
    status: ['FDB', 'ENR'],
    express: true,
    index: 2,
    header: 'signup.steps.FDB.header',
    title: 'signup.steps.FDB.title',
    subtitle: null,
    icon: 'evaluation',
    loading: false,
    cta: {
      toggle: false,
      text: null,
    },
    evaluation: {
      score: null,
      feedbacks: []
    }
  },
  'FDB': {
    status: 'FDB',
    express: false,
    index: 2,
    header: 'signup.steps.FDB.header',
    title: 'signup.steps.FDB.title',
    subtitle: null,
    icon: 'evaluation',
    loading: false,
    cta: {
      toggle: false,
      text: null,
    },
    evaluation: {
      score: null,
      feedbacks: []
    }
  },
  'SIG': {
    status: 'SIG',
    express: false,
    index: 3,
    suffix: 'A',
    header: 'signup.steps.SIG.header',
    title: 'signup.steps.SIG.title',
    subtitle: 'signup.steps.SIG.subtitle',
    icon: 'signature',
    loading: false,
    cta: {
      toggle: false,
      text: null,
    },
    profile: 0,
    envelopes: {
      completion: 0,
      items: {
        driver: {},
        owner: {}
      },
    },
    completion: 0,
  },
  'ENR': {
    status: ['ENR'],
    express: false,
    index: 3,
    suffix: 'B',
    header: 'signup.steps.ENR.header',
    title: 'signup.steps.ENR.title',
    subtitle: 'signup.steps.ENR.subtitle',
    icon: {
      'ENR': 'docs',
      'FDD': 'docs-eval',
    },
    loading: false,
    cta: {
      toggle: false,
      text: 'signup.steps.ENR.cta',
    },
    profile: 0,
    docs: {
      completion: 0,
      items: [],
    },
    completion: 0,
  },
  'REA': {
    status: 'REA',
    index: 4,
    header: 'signup.steps.REA.header',
    title: 'signup.steps.REA.title',
    subtitle: 'signup.steps.REA.subtitle',
    icon: 'ready',
    loading: false,
    cta: {
      toggle: false,
      text: null,
    },
    guidelines: {
      toggle: false,
      seen: false,
    },
    completion: 0,
  },
  'SCH': {
    status: 'SCH',
    index: 5,
    header: 'signup.steps.SCH.header',
    title: 'signup.steps.SCH.title',
    subtitle: 'signup.steps.SCH.subtitle',
    icon: 'schedule',
    loading: false,
    cta: {
      toggle: false,
      text: null,
    },
    guidelines: {
      toggle: false,
      seen: false,
    },
    completion: 0,
  },
}

export const docs = {
  'doc_cnh': {
    title: 'general.driver_license',
    subtitle: 'signup.steps.ENR.docs.license_subtitle',
    example: 'doc_cnh.jpg',
    loading: false,
    success: false,
  },
  'doc_app_perfil': {
    title: 'signup.steps.ENR.docs.profile',
    subtitle: 'signup.steps.ENR.docs.profile_subtitle',
    example: 'doc_app_perfil.jpg',
    loading: false,
    success: false,
  },
  'doc_app_horas1': {
    title: 'signup.steps.ENR.docs.hours',
    subtitle: 'signup.steps.ENR.docs.hours_subtitle',
    example: 'doc_app_horas.jpg',
    loading: false,
    success: false,
  },
  'doc_app_horas2': {
    title: 'signup.steps.ENR.docs.hours2',
    subtitle: 'signup.steps.ENR.docs.hours2_subtitle',
    example: 'doc_app_horas.jpg',
    loading: false,
    success: false,
  },
  'doc_app_horas3': {
    title: 'signup.steps.ENR.docs.hours3',
    subtitle: 'signup.steps.ENR.docs.hours3_subtitle',
    example: 'doc_app_horas.jpg',
    loading: false,
    success: false,
  },
  'doc_app_horas4': {
    title: 'signup.steps.ENR.docs.hours4',
    subtitle: 'signup.steps.ENR.docs.hours4_subtitle',
    example: 'doc_app_horas.jpg',
    loading: false,
    success: false,
  },
  'doc_veiculo': {
    title: 'signup.steps.ENR.docs.vehicle',
    subtitle: 'signup.steps.ENR.docs.vehicle_subtitle',
    example: 'doc_veiculo.jpg',
    loading: false,
    success: false,
  },
  'doc_veiculo_compra': {
    title: 'signup.steps.ENR.docs.vehicle_purchase',
    subtitle: 'signup.steps.ENR.docs.vehicle_purchase_subtitle',
    example: 'doc_veiculo_compra.jpg',
    loading: false,
    success: false,
  },
  'doc_residencia': {
    title: 'signup.steps.ENR.docs.residency',
    subtitle: 'signup.steps.ENR.docs.residency_subtitle',
    example: 'doc_residencia.jpg',
    loading: false,
    success: false,
  },
  'doc_foto_veiculo1': {
    title: 'signup.steps.ENR.docs.photo1',
    subtitle: 'signup.steps.ENR.docs.photo1',
    example: 'doc_foto_veiculo1.jpg',
    loading: false,
    success: false,
  },
  'doc_foto_veiculo2': {
    title: 'signup.steps.ENR.docs.photo2',
    subtitle: 'signup.steps.ENR.docs.photo2',
    example: 'doc_foto_veiculo2.jpg',
    loading: false,
    success: false,
  },
  'doc_foto_veiculo3': {
    title: 'signup.steps.ENR.docs.photo3',
    subtitle: 'signup.steps.ENR.docs.photo3',
    example: 'doc_foto_veiculo3.jpg',
    loading: false,
    success: false,
  },
  'doc_foto_veiculo4': {
    title: 'signup.steps.ENR.docs.photo4',
    subtitle: 'signup.steps.ENR.docs.photo4',
    example: 'doc_foto_veiculo4.jpg',
    loading: false,
    success: false,
  },
  'doc_rg_prop': {
    title: 'signup.steps.ENR.docs.owner_id',
    subtitle: 'signup.steps.ENR.docs.owner_id_subtitle',
    example: 'doc_rg.jpg',
    loading: false,
    success: false,
  },
  'doc_cpf_prop': {
    title: 'signup.steps.ENR.docs.owner_cpf',
    subtitle: 'signup.steps.ENR.docs.owner_cpf_subtitle',
    example: 'doc_cpf.jpg',
    loading: false,
    success: false,
  },
}

export default {
  steps,
  docs
}